import { render, staticRenderFns } from "./gridRowFixedBottom.vue?vue&type=template&id=244dbc8a&"
import script from "./gridRowFixedBottom.vue?vue&type=script&lang=js&"
export * from "./gridRowFixedBottom.vue?vue&type=script&lang=js&"
import style0 from "./gridRowFixedBottom.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports